import DOMPurify from "dompurify";

export const createLogEntry = (type, content) => {
  let that = {
    type,
    content,
    timestamp: new Date(),
  };

  that.text = function () {
    return that[that.type + "Text"]();
  };

  that.muteRequestText = function () {
    var res;

    if (that.content.source.isPublisher) {
      res = "You have muted ";
    } else {
      res = that.content.source.display + " has muted ";
    }
    if (that.content.target.isPublisher) {
      res += "you";
    } else {
      res += that.content.target.display;
    }
    return res;
  };

  that.chatMsgText = function () {
    return DOMPurify.sanitize(that.content.text);
  };

  that.publishScreenText = function () {
    return "Screen sharing started";
  };

  that.destroyFeedText = function () {
    if (that.content.feed.isLocalScreen) {
      return "Screen sharing stopped";
    } else {
      return that.content.feed.display + " has left the room";
    }
  };

  that.newRemoteFeedText = function () {
    return that.content.feed.display + " has joined the room";
  };

  that.ignoreFeedText = function () {
    return "You are ignoring " + that.content.feed.display + " now";
  };

  that.reconnectFeedText = function () {
    return "Connected again with " + that.content.feed.display;
  };

  that.hasText = function () {
    return that.text() !== "";
  };

  return that;
};
